// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsProductBrandStyles {
    brand?: ProductBrandStyles;
}

export const productDetailsProductBrandStyles: ProductDetailsProductBrandStyles = {
    brand: {
        logoImage: {
            css: css`
                height: 37px;
                max-width: 139px;
                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            `,
        },
        nameLink: {
            typographyProps: {
                css: css`
                    width: 198px;
                    height: 37px;
                    text-align: center;
                `,
            },
            css: css`
                &.showLogo {
                    & > ${TypographyStyle} {
                        width: 139px;
                        padding: 0 20px;
                    }
                }
            `,
        },
    },
};

const styles = productDetailsProductBrandStyles;

const ProductDetailsProductBrand: FC<Props> = ({ id, product }) => {
    if (!product || !product.brand || !product.brand.logoSmallImagePath) {
        return null;
    }
    return <ProductBrand brand={product.brand} showLogo={true} extendedStyles={styles.brand} />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsProductBrand),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
